module.exports = __webpack_public_path__ + "static/media/help-dark.d94094fb.svg";